import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar/Sidebar';
import Navbar from '../components/common/Navbar/Navbar';
import AdminDashboard from '../pages/admin/AdminDashboard';
import Mentors from '../pages/admin/Mentors';
import Students from '../pages/admin/Students';
import Managers from '../pages/admin/Managers';
import Counsellors from '../pages/admin/Counsellors';
import Projects from '../pages/admin/Projects';
import Classes from '../pages/admin/Classes';
import Assignments from '../pages/admin/Assignments';
import BillOfMaterials from '../pages/admin/BillOfMaterials';
import Competitions from '../pages/admin/Competitions';
import CompetitionWorkflow from '../pages/admin/CompetitionWorkflow';
import CompetitionSetup from '../pages/common/CompetitionSetup';
import CompetitionMatcherAccess from '../pages/common/CompetitionMatcherAccess';
// Role-agnostic despite its path: the review endpoints are open to every
// competition admin, not just POC owners.
import CompetitionReviewQueue from '../pages/pocOwner/PocOwnerReviewQueue';
import CompetitionDeadlineWatch from '../pages/common/CompetitionDeadlineWatch';
import Reports from '../pages/admin/Reports';
import Approvals from '../pages/admin/Approvals';
import AdminDisputes from '../pages/admin/AdminDisputes';
import ProjectDetails from '../pages/common/ProjectDetails';
import styles from './Routes.module.css';

const SuperAdminRoutes = () => {
  const menuItems = [
    { label: 'Dashboard', path: '/super-admin/dashboard', icon: 'dashboard' },
    { label: 'Mentors', path: '/super-admin/mentors', icon: 'mentors' },
    { label: 'Students', path: '/super-admin/students', icon: 'students' },
    { label: 'Managers', path: '/super-admin/managers', icon: 'managers' },
    { label: 'Counsellors', path: '/super-admin/counsellors', icon: 'counsellors' },
    { label: 'Projects', path: '/super-admin/projects', icon: 'projects' },
    { label: 'Classes', path: '/super-admin/classes', icon: 'classes' },
    { label: 'Assignments', path: '/super-admin/assignments', icon: 'assignments' },
    { label: 'Bill of Materials', path: '/super-admin/bom', icon: 'materials' },
    { label: 'Competition Matcher', path: '/super-admin/comp-matcher', icon: 'competitions' },
    { label: 'Competition Review', path: '/super-admin/comp-review', icon: 'assignments' },
    { label: 'Competitions', path: '/super-admin/competitions', icon: 'competitions' },
    { label: 'Competition Setup', path: '/super-admin/competition-setup', icon: 'materials' },
    { label: 'Approaching Deadlines', path: '/super-admin/comp-deadlines', icon: 'milestones' },
    { label: 'Journal Tracker', path: '/super-admin/competitions-legacy', icon: 'reports' },
    { label: 'Reports', path: '/super-admin/reports', icon: 'reports' },
    { label: 'Approvals', path: '/super-admin/approvals', icon: 'approvals' },
    { label: 'Disputes', path: '/super-admin/disputes', icon: 'disputes' }
  ];

  return (
    <div className={styles.layout}>
      <Sidebar menuItems={menuItems} role="super_admin" />
      <div className={styles.mainContent}>
        <Navbar title="COSMIC Super Admin" />
        <div className={styles.content}>
          <Routes>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="mentors" element={<Mentors />} />
            <Route path="students" element={<Students />} />
            <Route path="managers" element={<Managers />} />
            <Route path="counsellors" element={<Counsellors />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:projectId" element={<ProjectDetails />} />
            <Route path="classes" element={<Classes />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="bom" element={<BillOfMaterials />} />
            <Route path="comp-matcher" element={<CompetitionMatcherAccess />} />
            <Route path="comp-review" element={<CompetitionReviewQueue />} />
            <Route path="competitions" element={<CompetitionWorkflow />} />
            <Route path="competition-setup" element={<CompetitionSetup />} />
            <Route path="comp-deadlines" element={<CompetitionDeadlineWatch />} />
            <Route path="competitions-legacy" element={<Competitions />} />
            <Route path="reports" element={<Reports />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="disputes" element={<AdminDisputes />} />
            <Route path="/" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminRoutes;